import { ToggleButton as MuiToggleButton } from '@material-ui/lab'
import React, { forwardRef } from 'react'
import { ToggleButtonProps } from './ToggleButtonProps'
import { useToggleButtonStyles } from './ToggleButtonStyles'

export const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  ({ color = 'primary', ...restProps }, ref) => {
    const props = { ...restProps, color }
    const { children, ...muiProps } = props
    const classes = useToggleButtonStyles(props)

    return (
      <MuiToggleButton
        ref={ref}
        classes={{
          root: classes.root,
          selected: classes.selected,
        }}
        {...muiProps}
      >
        {children}
      </MuiToggleButton>
    )
  },
)

ToggleButton.displayName = 'ToggleButton'
